let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("6ACCg"), load("4HZlX")]).then(() => parcelRequire('1w5AW'));